import { useMutation } from '@tanstack/react-query';
import oaiApiClient from '../clients/oai-api/oai-api-client';

export const useMarkNotificationAsRead = () => {
  return useMutation<string, string, string>({
    mutationKey: ['notifications-mutation'],
    mutationFn: async (id) => {
      if (!id) {
        throw new Error('id is required');
      }

      return oaiApiClient.markNotificationAsRead(id);
    },
  });
};
